import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { normalizeSize } from '../../utils'

const Truncate = ({ children, className, width, as }) => {
  const classList = classNames('to-ellipsis o-hidden ws-nowrap', className)
  const styles = {
    maxWidth: normalizeSize(width)
  }
  const Wrapper = as;
  return (
    <Wrapper className={classList} style={styles}>
      {children}
    </Wrapper>
  )
}

Truncate.propTypes = {
  /**
   * Classes to be added to the component
   */
  className: PropTypes.string,
  /**
   * Width at which to truncate text
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Text to be truncated
   */
  children: PropTypes.node,
/**
 * Element to be wrapped around text
 */
  as: PropTypes.oneOf(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'div', 'span'])
}

Truncate.defaultProps = {
  width: '100%',
  className: '',
  children: null,
  as: 'p'
}

Truncate.displayName = 'Truncate'

export { Truncate };
